export default __webpack_public_path__ + "static/media/Relatorios (Real Size).2d0fa66d.svg";